import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import {
  TOGGLE_PAYER,
  TOGGLE_PROVIDER,
  TOGGLE_MY_ACCOUNT,
  TOGGLE_NAV_ITEM,
} from './constants';

export const togglePayer = (isOpen) => {
  return createAction({
    type: TOGGLE_PAYER,
    payload: isOpen,
  });
};

export const toggleProvider = (isOpen) => {
  return createAction({
    type: TOGGLE_PROVIDER,
    payload: isOpen,
  });
};

export const toggleMyAccount = (isOpen) => {
  return createAction({
    type: TOGGLE_MY_ACCOUNT,
    payload: isOpen,
  });
};

export const toggleNavItem = (isOpen) => {
  return createAction({
    type: TOGGLE_NAV_ITEM,
    payload: isOpen,
  });
};
